const AvailabilitySource = ({
    localHotelDetailsState,
    setLocalHotelDetailsState,
    pa,
    setPa
}) => {
    const availabilityOptions = [
        { label: "Reception", value: "RECEPTION" }, 
        { label: "Channel Manager", value: "CHANNEL_MANAGER" }
    ]
    return (
        <div className="mt-8">
            <div className="font-body text-[18px] mb-2">
                Availability Source
            </div>
            <div className="flex items-center gap-6">
                {availabilityOptions.map(priceOption => (
                    <div key={"availability_" + priceOption?.value} className="flex items-center gap-2">
                        <input
                            type="radio"
                            className="accent-primary"
                            name="availability-source"
                            checked={pa?.bookingEngineAvailabilitySource === priceOption?.value}
                            onChange={() =>{
                                const newPa = { ...pa,
                                        bookingEngineAvailabilitySource:  priceOption?.value,
                                    };
                                setLocalHotelDetailsState({
                                    ...localHotelDetailsState,
                                    priceAdjustment: {
                                     ...newPa
                                }});
                                setPa({...newPa});
                            }
                            }
                        />
                        <label className="capitalize">{priceOption?.label}</label>
                    </div>
                ))}
            </div></div>
    );

}
export default AvailabilitySource;